/**
 * Shared TanStack Query keys for offerings hooks.
 *
 * IMPORTANT: Values here MUST remain identical to prior inline definitions —
 * downstream cache behavior depends on exact key shape.
 */

export const OFFERINGS_QUERY_KEY = ["offerings"] as const;

export const offeringsKeys = {
  all: OFFERINGS_QUERY_KEY,
  paginated: (first: number, offset: number, filter: Record<string, unknown> | undefined) =>
    [...OFFERINGS_QUERY_KEY, "paginated", first, offset, filter] as const,
  paginatedBase: () => [...OFFERINGS_QUERY_KEY, "paginated"] as const,
  single: (id: string) => [...OFFERINGS_QUERY_KEY, "single", id] as const,
} as const;
